import { breakpoints } from './breakpoints'
import { shape } from './shape'
import { spacing } from './spacing'
import { createTheme } from '@mui/material/styles'
import { deepmerge } from '@mui/utils'
import { baseTypography } from './typography/base-typography'
import { Palette } from '../../model/Palette'

const defaultTheme = createTheme()

export const baseThemeOptions = deepmerge(defaultTheme, {
  typography: baseTypography,
  breakpoints,
  palette: {
    common: {
      black: Palette.BLACK_OUT,
      white: Palette.WHITE,
    },
  },
  shape,
  spacing,
})
